import { Reducer } from 'umi';

const namespace = 'opinionAIShortIdFilter';
type stateType = {
  oriFilter: any;
};

const customModel: {
  namespace: string;
  state: stateType;
  reducers: {
    save: Reducer<stateType>;
  };
} = {
  namespace,
  state: {
    oriFilter: {},
  },
  reducers: {
    save(state: stateType, { payload }) {
      return { oriFilter: payload };
    },
  },
};

export default customModel;
